const container = {
  position: 'fixed' as const,
  top: 0,
  left: '50%',
  transform: 'translate(-50%, -80%)',
  backgroundColor: '#ECFCFF',
  width: 1000,
  height: 60,
  padding: '1rem 2rem',
  boxShadow: '0 2px 10px rgba(0, 0, 0, 0.1)',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  gap: '1rem',
  transition: 'transform 0.4s ease, opacity 0.4s ease',
  opacity: 0,
  zIndex: 9999,
}

const show = {
  transform: 'translate(-50%, 16px)',
  opacity: 1,
}

const hide = {
  transform: 'translate(-50%, -100%)',
  opacity: 0,
}

const closeButton = {
  position: 'absolute' as const,
  right: 10,
}

const description = {
  marginRight: 20,
  alignContent: 'center',
}

const contentContainer = {
  display: 'flex',
  flexDirection: 'row' as const,
}

export default {
  container,
  show,
  hide,
  closeButton,
  description,
  contentContainer,
}
